module.exports = __webpack_public_path__ + "media/images/banners/silde-2-33de80c10929e9d32a20fe9aba20c37f.jpg";